export const modifyTime = (d: string) => {
  const date = new Date(d);
  const options: Intl.DateTimeFormatOptions = {
    hour: 'numeric',
    minute: 'numeric',
    hour12: false,
  };

  return date.toLocaleString('ru-RU', options);
};

export const modifyDate = (d?: string): string => {
  if (!d) return '';
  const date = new Date(d);
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  };

  return date.toLocaleString('ru-RU', options);
};
